<div class="calc-card">
  <div class="calc-controls">
    <label class="field">
      <span class="field-label">مبلغ سرمایه‌گذاری</span>
      <span class="field-in">
        <input type="text" inputmode="numeric" autocomplete="off" maxlength="20" [value]="amountText()"
               (input)="onAmountInput($event)" placeholder="مثلاً ۵۰۰٬۰۰۰٬۰۰۰">
        <em>ریال</em>
      </span>
    </label>

    <div class="amount-chips" role="group" aria-label="مبلغ‌های آماده">
      @for (p of presets; track p.amount) {
        <button type="button" [class.active]="amount() === p.amount" [attr.aria-pressed]="amount() === p.amount"
                (click)="setAmount(p.amount)">{{ p.label }}</button>
      }
    </div>

    <div class="field" role="group" aria-labelledby="calc-period-label">
      <span class="field-label" id="calc-period-label">اگر این مدت پیش خریده بودید</span>
      <div class="seg">
        @for (p of periods; track p.months) {
          <button type="button" [class.active]="months() === p.months" [attr.aria-pressed]="months() === p.months"
                  (click)="setMonths(p.months)">{{ p.label }}</button>
        }
      </div>
    </div>
  </div>

  <div class="calc-result" aria-live="polite" [class.is-loading]="loading()">
    <div class="cr-label">ارزش امروز سرمایه‌ی شما با خرید {{ periodLabel() }} پیش</div>
    <div class="cr-value">{{ shownText() }} <em>ریال</em></div>
    @if (outcome(); as o) {
      <div class="cr-profit" [class.loss]="!o.gain">{{ o.text }}</div>
      <div class="cr-bar" aria-hidden="true">
        <div class="cr-bar-fill" [style.width.%]="o.bar"></div>
      </div>
    } @else {
      <div class="cr-profit muted">
        {{ failed() ? 'محاسبه انجام نشد؛ دوباره امتحان کنید.' : (amount() ? 'در حال محاسبه…' : 'مبلغ را وارد کنید.') }}
      </div>
      <div class="cr-bar" aria-hidden="true">
        <div class="cr-bar-fill"></div>
      </div>
    }
    <p class="cr-note">
      محاسبه بر پایه‌ی قیمت طلای آب‌شده در بازر در همان روز و قیمت امروز است؛ بازدهی گذشته تضمینی برای آینده نیست.
    </p>
  </div>
</div>
